export function formatPrice(cents: number) {
    const currency = new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currency: 'USD',
    });

    const placeholder = currency.format(0).replaceAll('0', '-');

    if (typeof cents !== 'number') return placeholder;
    if (Number.isNaN(cents)) return placeholder;
    if (!Number.isFinite(cents)) return placeholder;
    if (cents <= 0) return placeholder;

    return currency.format(Math.floor(cents) / 100);
}
